import uniqBy from 'lodash/uniqBy';

import {
	transformActivityData,
	notEmpty,
	notArchived,
	notDeleted,
} from '../homeViewsQueryHelpers.ts';

import type { RecentListHomeRecentWorkV3Query as RecentListHomeRecentWorkV3Query$data } from './__types__/RecentListHomeRecentWorkV3Query.ts';
import { ALL_RECENT_ITEMS_COUNT_HOME_REFRESH } from './recentListConstants.ts';

/**
 * Normalises the recent-work activity feed into the list the ForYou view renders: transformed,
 * de-duplicated by content id, with archived/deleted/empty entries dropped.
 *
 * Lives in its own leaf module rather than in `RecentList.tsx` because
 * `useIsEligibleForHideRecents` needs only this function — importing it from `RecentList.tsx`
 * pulled that whole ~485-line component module (and its Compiled styles, analytics and
 * browser-metrics imports) into everything that touched the eligibility hook, including its tests.
 */
export const filteredRecents = (
	data: RecentListHomeRecentWorkV3Query$data | undefined,
	isShowingMore: boolean,
	firstPageSize: number = ALL_RECENT_ITEMS_COUNT_HOME_REFRESH,
): any[] => {
	const recents = uniqBy(
		(data?.activity?.myActivity?.all?.edges || [])
			.map((edge) => edge?.node)
			.map((node) => transformActivityData(node, true))
			.filter(notEmpty)
			.filter((node) => notEmpty(node.object?.data))
			.filter((node) => notArchived(node.object?.data))
			.filter((node) => notDeleted(node.object?.data)),
		(node) => node.object?.data?.id,
	);
	if (isShowingMore) {
		return recents;
	}
	return recents.slice(0, firstPageSize);
};
